import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AppLayout from "@/AppLayout.vue";

// User
import LoginPageView from "@/user/views/LoginPageView.vue";
import UserInfoPage from "@/user/views/UserInfoPage.vue";
import FindAccountPage from "@/user/views/FindAccountPageView.vue";
import UserLayout from "@/user/views/UserLayout.vue";

// Lotto
import LottoWrapperView from "@/lotto/views/LottoWrapperView.vue";
import LottoHomeView from "@/lotto/views/LottoHomeView.vue";
import LottoRecentView from "@/lotto/views/LottoRecentView.vue";
import LottoCreateView from "@/lotto/views/LottoCreateView.vue";
import LottoResultView from "@/lotto/views/LottoResultView.vue";
import LottoBuyListView from "@/lotto/views/LottoBuyListView.vue";
import LottoEtcView from "@/lotto/views/LottoEtcView.vue";
import LottoAnalysisView from "@/lotto/views/LottoAnalysisView.vue";

// Insta
import InstaWrapperView from "@/insta/views/InstaWrapperView.vue";
import InstaHomeView from "@/insta/views/InstaHomeView.vue";
import InstaUnfowerPage from "@/insta/views/InstaUnfolowerPage.vue";

// Apt
import AptWrapperView from "@/apt/views/AptWrapperView.vue";
import AptHomeView from "@/apt/views/AptHomeView.vue";
import AptTradeView from "@/apt/views/AptTradeView.vue";
import AptStatsView from "@/apt/views/AptStatsView.vue";
import AptFavoriteView from "@/apt/views/AptFavoriteView.vue";
import AptNewsView from "@/apt/views/AptNewsView.vue";
import AptGlossaryView from "@/apt/views/AptGlossaryView.vue";

// FamilyEvent
import FamilyEventWrapperView from "@/familyEvent/views/FamilyEventWrapperView.vue";
import FamilyEventHomeView from "@/familyEvent/views/FamilyEventHomeView.vue";

// Closet
import ClosetWrapperView from "@/closet/views/ClosetWrapperView.vue";
import ClosetHomeView from "@/closet/views/ClosetHomeView.vue";
import ClosetWardrobeView from "@/closet/views/ClosetWardrobeView.vue";
import ClosetClothingFormView from "@/closet/views/ClosetClothingFormView.vue";
import ClosetClothingDetailView from "@/closet/views/ClosetClothingDetailView.vue";
import ClosetBodyView from "@/closet/views/ClosetBodyView.vue";
import ClosetGuideView from "@/closet/views/ClosetGuideView.vue";

// Keyword
import KeywordWrapperView from "@/keyword/views/KeywordWrapperView.vue";
import KeywordHomeView from "@/keyword/views/KeywordHomeView.vue";
import KeywordPopularView from "@/keyword/views/KeywordPopularView.vue";
import KeywordSearchView from "@/keyword/views/KeywordSearchView.vue";
import KeywordTitleView from "@/keyword/views/KeywordTitleView.vue";
import KeywordDetailView from "@/keyword/views/KeywordDetailView.vue";

// Admin
import AdminWrapperView from "@/admin/views/AdminWrapperView.vue";
import MemberManageView from "@/admin/views/MemberManageView.vue";

// About
import AboutView from "@/common/views/AboutView.vue";

import NotFoundPageView from "@/common/views/NotFoundPage.vue";

import * as core from "@/common/utils/core";
import * as routerUtil from "@/common/utils/routerUtil";
import { applySeo } from "@/common/utils/seo";

export const routes: Array<RouteRecordRaw> = [
  // {
  //   path: "/user/login",
  //   name: "loginPage",
  //   component: LoginPageView,
  // },
  // {
  //   path: "/lotto",
  //   name: "lotto-home",
  //   component: LottoHomeView,
  // },
  {
    path: "/",
    component: AppLayout,
    children: [
      {
        path: "",
        name: "about",
        component: AboutView,
        meta: {
          title: "Breezer - 로또분석, 아파트 실거래가, 경조사 관리, 나의 옷장",
          metaTags: [
            {
              name: "description",
              content:
                "로또 분석, 아파트 실거래가 조회, 부동산 소식, 인스타 언팔 찾기, 경조사 관리, 나의 옷장(의류 사이즈 기록) 등 다양한 생활 편의 서비스를 제공합니다.",
            },
            {
              property: "og:title",
              content: "Breezer - 생활 편의 서비스 모음",
            },
            {
              property: "og:description",
              content:
                "로또 분석, 아파트 실거래가, 부동산 소식, 인스타 언팔 찾기, 경조사 관리, 나의 옷장 등 생활 편의 서비스",
            },
          ],
        },
      },
      {
        path: "lotto",
        name: "lotto-wrapper",
        redirect: "/lotto/home",
        component: LottoWrapperView,
        meta: {
          title: "Breezer - 로또분석",
          metaTags: [
            {
              name: "description",
              content: "최신 로또 결과를 쉽게 확인하세요.",
            },
            { property: "og:title", content: "로또 분석 - Breezer" },
            {
              property: "og:description",
              content: "당첨 결과와 자동 번호 생성 제공",
            },
          ],
        },
        children: [
          {
            path: "home",
            name: "lotto-home",

            component: LottoHomeView,
          },
          {
            path: "recent",
            name: "lotto-recent",
            meta: { auth: true },
            component: LottoRecentView,
          },
          {
            path: "generate",
            name: "lotto-create",
            component: LottoCreateView,
          },
          {
            path: "result",
            name: "lotto-result",
            component: LottoResultView,
          },
          {
            path: "buy-list",
            name: "lotto-buylist",
            component: LottoBuyListView,
          },
          {
            path: "analysis",
            name: "lotto-analysis",
            component: LottoAnalysisView,
          },
          {
            path: "etc",
            name: "lotto-etc",
            component: LottoEtcView,
          },
        ],
      },
      {
        path: "speakingnote",
        name: "speakingnote",
        meta: { auth: true },
        component: LottoHomeView,
      },
      {
        path: "insta",
        name: "insta-wrapper",
        redirect: "/insta/home",
        component: InstaWrapperView,
        meta: {
          title: "Breezer 인스타 언팔로우 찾기",
          metaTags: [
            {
              name: "description",
              content: "나와 맞팔이 아닌 사람을 찾아보세요",
            },
            { property: "og:title", content: "인스타 언팔 찾기" },
            {
              property: "og:description",
              content: "나와 맞팔이 아닌 팔로잉 찾기",
            },
          ],
        },
        children: [
          {
            path: "home",
            name: "insta-home",

            component: InstaHomeView,
          },
          {
            path: "unfollower",
            name: "insta-unfollower",
            component: InstaUnfowerPage,
          },
        ],
      },
      {
        path: "apt",
        name: "apt-wrapper",
        redirect: "/apt/home",
        component: AptWrapperView,
        meta: {
          title: "Breezer 아파트 실거래가 조회",
          metaTags: [
            {
              name: "description",
              content: "아파트 실거래가를 조회해 보세요",
            },
            { property: "og:title", content: "아파트 실거래가 조회" },
            {
              property: "og:description",
              content: "서울 아파트 실 거래가 조회",
            },
          ],
        },
        children: [
          {
            path: "home",
            name: "apt-home",
            component: AptHomeView,
          },
          {
            path: "news",
            name: "apt-news",
            component: AptNewsView,
            meta: {
              title: "Breezer - 부동산 소식",
              metaTags: [
                {
                  name: "description",
                  content:
                    "매월 정리하는 부동산 시장 동향, 정책 변화, 서울 아파트 시세 분석 리포트를 제공합니다.",
                },
                {
                  property: "og:title",
                  content: "부동산 월간 리포트 - Breezer",
                },
                {
                  property: "og:description",
                  content:
                    "부동산 정책, 금리, 시장 동향을 매월 정리",
                },
              ],
            },
          },
          {
            path: "trade",
            name: "apt-trade-search",
            component: AptTradeView,
          },
          {
            path: "stats",
            name: "apt-stats",
            component: AptStatsView,
            meta: {
              title: "Breezer - 아파트 통계 분석",
              metaTags: [
                {
                  name: "description",
                  content:
                    "서울 아파트 실거래 데이터를 자치구·평형·기간 조건으로 집계하고 비교 분석합니다.",
                },
                {
                  property: "og:title",
                  content: "아파트 통계 분석 - Breezer",
                },
              ],
            },
          },
          {
            path: "favorite",
            name: "apt-favorite",
            meta: { auth: true },
            component: AptFavoriteView,
          },
          {
            path: "glossary",
            name: "apt-glossary",
            component: AptGlossaryView,
            meta: {
              title: "Breezer - 부동산 용어사전",
              metaTags: [
                {
                  name: "description",
                  content:
                    "부동산 거래, 세금, 재건축, 대출, 지표 등 핵심 부동산 용어를 쉽게 검색하고 이해하세요.",
                },
                {
                  property: "og:title",
                  content: "부동산 용어사전 - Breezer",
                },
                {
                  property: "og:description",
                  content:
                    "부동산 핵심 용어 40여개를 카테고리별로 정리",
                },
              ],
            },
          },
        ],
      },
      {
        path: "family-event",
        name: "family-event-wrapper",
        redirect: "/family-event/home",
        component: FamilyEventWrapperView,
        meta: {
          title: "Breezer 경조사 관리",
          metaTags: [
            {
              name: "description",
              content: "경조사 내역을 관리해 보세요",
            },
            { property: "og:title", content: "경조사 관리 - Breezer" },
            {
              property: "og:description",
              content: "경조사 내역 등록 및 조회",
            },
          ],
        },
        children: [
          {
            path: "home",
            name: "family-event-home",
            meta: { auth: true },
            component: FamilyEventHomeView,
          },
        ],
      },
      {
        path: "closet",
        name: "closet-wrapper",
        redirect: "/closet/home",
        component: ClosetWrapperView,
        meta: {
          title: "Breezer 나의 옷장",
          metaTags: [
            {
              name: "description",
              content:
                "나의 신체 치수와 의류 사이즈를 기록하고 관리하세요",
            },
            { property: "og:title", content: "나의 옷장 - Breezer" },
            {
              property: "og:description",
              content: "브랜드별 의류 사이즈 기록 및 추천",
            },
          ],
        },
        children: [
          {
            path: "home",
            name: "closet-home",
            component: ClosetHomeView,
          },
          {
            path: "wardrobe",
            name: "closet-wardrobe",
            meta: { auth: true },
            component: ClosetWardrobeView,
          },
          {
            path: "clothing/register",
            name: "closet-clothing-register",
            meta: { auth: true },
            component: ClosetClothingFormView,
          },
          {
            path: "clothing/:id",
            name: "closet-clothing-detail",
            meta: { auth: true },
            component: ClosetClothingDetailView,
            props: true,
          },
          {
            path: "clothing/:id/edit",
            name: "closet-clothing-edit",
            meta: { auth: true },
            component: ClosetClothingFormView,
            props: true,
          },
          {
            path: "guide",
            name: "closet-guide",
            meta: { auth: true },
            component: ClosetGuideView,
          },
          {
            path: "body",
            name: "closet-body",
            meta: { auth: true },
            component: ClosetBodyView,
          },
        ],
      },
      {
        path: "keyword",
        name: "keyword-wrapper",
        redirect: "/keyword/home",
        component: KeywordWrapperView,
        meta: {
          title: "Breezer - 키워드 리서치",
          // 데이터 조회는 비공개지만 홈은 서비스 소개라 접근 자체는 열어둔다.
          // 색인은 막아둔다 — 권한자만 쓸 수 있는 도구라 검색 유입이 의미 없다.
          // (소개 페이지만 색인하고 싶어지면 이 줄을 home 하위로 옮기면 된다)
          metaTags: [{ name: "robots", content: "noindex, nofollow" }],
        },
        children: [
          {
            // 홈은 로그인 여부와 무관하게 항상 소개 화면이다.
            // 여기서 키워드를 입력하면 /keyword/search?q= 로 넘어간다.
            // 비로그인이면 로그인 화면을 거쳐 같은 곳으로 복귀한다(nextRoute).
            path: "home",
            name: "keyword-home",
            component: KeywordHomeView,
          },
          {
            // 인기 키워드는 비로그인 열람 허용(백엔드 시스템 기본 키). 클릭 시 검색/상세는 로그인 필요.
            path: "popular",
            name: "keyword-popular",
            component: KeywordPopularView,
          },
          {
            path: "search",
            name: "keyword-search",
            meta: { auth: true },
            component: KeywordSearchView,
          },
          {
            path: "title",
            name: "keyword-title",
            meta: { auth: true },
            component: KeywordTitleView,
          },
          {
            path: "detail/:keyword",
            name: "keyword-detail",
            meta: { auth: true },
            component: KeywordDetailView,
            props: true,
          },
        ],
      },
      {
        path: "admin",
        name: "admin-wrapper",
        redirect: "/admin/members",
        component: AdminWrapperView,
        meta: {
          auth: true,
          title: "Breezer - 관리",
        },
        children: [
          {
            path: "members",
            name: "admin-members",
            meta: { auth: true },
            component: MemberManageView,
          },
          {
            path: "permission",
            name: "admin-permission",
            meta: { auth: true },
            component: () => import("@/user/views/PermissionManageView.vue"),
          },
          {
            // 서비스별 개방 상태(실시간 on/off)와 외부 API 사용량
            path: "service",
            name: "admin-service",
            meta: { auth: true },
            component: () => import("@/admin/views/ServiceManageView.vue"),
          },
        ],
      },
      {
        path: "test",
        name: "testpage",
        component: () => import("@/common/views/TestPage.vue"),
      },
    ],
  },
  {
    path: "/user",
    component: UserLayout,
    children: [
      {
        path: "login",
        name: "login",
        component: LoginPageView,
      },
      {
        path: "join",
        name: "join",
        component: UserInfoPage,
      },
      {
        path: "info",
        name: "info",
        component: UserInfoPage,
        meta: { auth: true },
      },
      {
        path: "permission",
        name: "permission",
        component: () => import("@/user/views/PermissionManageView.vue"),
        meta: { auth: true },
      },
      {
        path: "find",
        name: "find",
        component: FindAccountPage,
      },
      {
        path: "terms",
        name: "termspage",
        component: () => import("@/user/views/TermsPage.vue"),
      },
      {
        path: "terms-of-service",
        name: "terms-of-service",
        component: () => import("@/user/views/TermsOfServicePage.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFoundPageView",
    component: NotFoundPageView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

const noSessionNeedPage = (to: any) => {
  const list = ["login", "join", "find"];
  return list.includes(to.name);
};

/** 로그인/회원가입 계열 경로인지 (복귀 주소가 여기면 무한 루프가 된다) */
const noSessionNeedPath = (path: string) => /^\/user\/(login|join|find)/.test(path);

/**
 * nextRoute 쿼리 파싱. encodeURIComponent(JSON.stringify({ path, query })) 형태.
 * path 가 http 로 시작하면 외부 서비스(코트브리즈 등) 절대 URL이다.
 */
const parseNextRoute = (
  raw: any
): { path: string; query: Record<string, any> } | null => {
  if (typeof raw !== "string" || !raw) return null;
  try {
    const decoded = JSON.parse(decodeURIComponent(raw));
    if (typeof decoded?.path !== "string") return null;
    return { path: decoded.path, query: decoded.query ?? {} };
  } catch (e) {
    console.error("nextRoute parse error", e);
    return null;
  }
};

router.beforeEach(async (to, from, next) => {
  ///////////////////////
  // SEO 메타 (title / description / canonical / og) — 라우트별 갱신
  // SPA라 라우트가 바뀌어도 초기 HTML 메타가 남으므로(특히 canonical이 홈으로
  // 고정되면 전 페이지가 홈의 중복 처리됨) 매 이동마다 현재 경로 기준으로 갱신한다.
  applySeo(to.path);

  ///////////////////////
  // session / auth 체크
  console.log("[Router beforeEach]");
  const requiresAuth = to.meta.auth === true;
  // 비인증 페이지로 이동 시 silent 모드 (세션만료 알럿 안 띄움)
  const session = await core.sessionCheck(!requiresAuth);
  console.log("session : ", session);
  console.log("auth : ", to.meta.auth);
  console.log("to : ", to);

  if (requiresAuth && !session) {
    // 인증 필요 페이지인데 로그인 안 됨 → 로그인 여부 확인
    console.log("권한없음");
    const yes = confirm("로그인이 필요합니다");
    if (yes) {
      const nextRoute = encodeURIComponent(
        JSON.stringify({ path: to.fullPath })
      );
      routerUtil.moveTo("/user/login", nextRoute);
    } else {
      next(false);
    }
  } else if (session && noSessionNeedPage(to)) {
    // 로그인 상태에서 로그인/회원가입 페이지 접근.
    // 복귀 주소(nextRoute)가 있으면 그리로 보낸다 —
    // 코트브리즈처럼 외부 서비스에서 넘어온 경우 홈으로 보내면 원래 화면을 잃는다.
    const back = parseNextRoute(to.query.nextRoute);
    if (back && back.path.startsWith("http")) {
      window.location.href = back.path;
      next(false);
      return;
    }
    if (back && back.path.startsWith("/") && !noSessionNeedPath(back.path)) {
      next({ path: back.path, query: back.query });
      return;
    }
    console.log("이미 로그인된 상태입니다. 홈 화면으로 이동합니다.");
    next({ name: "lotto-home" });
  } else {
    next();
  }
});

export default router;
